import https from "../../base/utils/http";
import AuthService from "../../base/services/authentication.service";
import { LocalStorageService } from "../../base/services/local-storage.service";
import { SUPPORT_EMAIL } from "./billingCodes";

// What our team hears of an Enterprise request. The backend records the request
// (enterprise.js) but tells nobody, so the platform sends it the way the
// website's contact form does: POST /LandingPage, which takes no sign in,
// emails our team at info@kaptechgroup.com and sends the person a confirmation.
// It goes out once the request is recorded, with what the person wrote about
// the plan they need.

/** Where on the platform Enterprise was asked for, as the email names it. */
export const EnterpriseRequestSource = Object.freeze({
   SIGN_UP: "sign-up",
   BILLING_PAGE: "billing page",
   SUBSCRIPTION_PAGE: "Subscription page"
});

/** Said when the request is recorded and our team's email couldn't be sent. */
export const ENTERPRISE_MESSAGE_NOT_SENT = `Your Enterprise request is recorded, but your message didn't reach our team. Please write to ${SUPPORT_EMAIL} with what you need.`;

/** The email's text: where the request came from, for which organization, and what it needs. */
export const buildEnterpriseRequestMessage = ({ needs, organizationName, organizationId, source }) =>
   [
      `Enterprise plan request from the KAPsurvey platform (${source}).`,
      "",
      `Organization: ${organizationName || "-"}`,
      `Organization ID: ${organizationId || "-"}`,
      "",
      "What they need:",
      needs?.trim() || "Not written yet. Please contact them to agree the terms."
   ].join("\n");

/** Who is asking, for a signed-in organization (the billing page, the Subscription page). */
export const signedInRequester = () => {
   const user = AuthService.getUser();
   return {
      name: user?.fullName,
      email: user?.email,
      phone: user?.phoneNumber,
      organizationName: LocalStorageService.getItem("organizationName"),
      organizationId: AuthService.getOrganizationId()
   };
};

/**
 * Sends our team the Enterprise request. Resolves true once the email has gone
 * out, false when it couldn't be (or there is no address to answer); never
 * rejects, since the request itself is already recorded. The endpoint's
 * `subject` is the body of the email it sends.
 */
export async function notifyEnterpriseRequest({
   name,
   email,
   phone,
   organizationName,
   organizationId,
   source,
   needs
}) {
   if (!email) return false;

   try {
      const response = await https.post("/LandingPage", {
         getInTouch: {
            name: name?.trim() || email,
            email,
            phone: phone || null,
            company: organizationName || null,
            subject: buildEnterpriseRequestMessage({ needs, organizationName, organizationId, source })
         }
      });
      return response?.data?.isSuccess !== false;
   } catch {
      return false;
   }
}
